export default "__VITE_ASSET__BUIeotOQ__"